import { render } from "./InformeExtrusion.vue?vue&type=template&id=e46ec3b0&scoped=true"
import script from "./InformeExtrusion.vue?vue&type=script&lang=js"
export * from "./InformeExtrusion.vue?vue&type=script&lang=js"

import "./InformeExtrusion.vue?vue&type=style&index=0&id=e46ec3b0&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/CERAMICAS/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e46ec3b0"]])

export default __exports__